(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2923],{

/***/ 82923:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(2784);
function YemaLogoHorizontalBlackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 280 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A19",
    d: "M180.987 10h-34.618c-7.192 0-13.018 5.833-13.018 13.018v34.014c0 7.192 5.826 13.018 13.018 13.018h34.618c7.192 0 13.018-5.826 13.018-13.018V23.018c0-7.185-5.826-13.018-13.018-13.018zM36.626 10h-.604C19.442 10 6 23.442 6 40.029a29.908 29.908 0 008.796 21.225 29.894 29.894 0 0021.226 8.796h.604c16.586 0 30.029-13.442 30.029-30.021a29.914 29.914 0 00-8.797-21.233A29.913 29.913 0 0036.626 10zM117.261 10H82.644c-7.193 0-13.019 5.833-13.019 13.018v34.014c0 7.192 5.826 13.018 13.019 13.018h34.617c7.193 0 13.018-5.826 13.018-13.018V23.018c0-7.185-5.825-13.018-13.018-13.018zM244.741 10h-34.617c-7.193 0-13.019 5.833-13.019 13.018v34.014c0 7.192 5.826 13.018 13.019 13.018h34.617c7.185 0 13.019-5.826 13.019-13.018V23.018c0-7.185-5.834-13.018-13.019-13.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M44.468 29.466L37.18 42.827v7.966h-1.358v-7.966l-7.275-13.361h1.515l6.439 11.95 6.438-11.95h1.529zM94.215 29.466h11.976v1.201H95.573v8.424h9.573v1.189h-9.573v9.312h10.618v1.201H94.215V29.466zM156.934 29.466h1.999l3.082 8.163a162.478 162.478 0 011.711 4.91h.026a137.194 137.194 0 011.711-4.91l3.082-8.163h1.998v21.328h-1.253v-19.93h-.026a232.969 232.969 0 01-2.129 5.732l-2.821 7.576h-1.15l-2.821-7.575c-.653-1.738-1.28-3.37-2.128-5.734h-.026v19.93h-1.255V29.467zM231.54 43.4l-2.051-6.306a1136.34 1136.34 0 01-2.037-6.453h-.039c-.732 2.338-1.358 4.324-2.037 6.453l-2.051 6.307h8.215zm.404 1.23h-9.024l-1.998 6.164h-1.437l6.988-21.328h1.92l6.986 21.328h-1.436l-1.999-6.165z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A19",
    d: "M267.678 25.83h1.331c.73 0 1.055-.366 1.055-1.135 0-.745-.351-.991-1.029-.991h-1.357v2.125zm2.125.585l1.214 2.517h-.925l-1.123-2.412h-1.291v2.412h-.821v-5.946h2.217c1.252 0 1.864.56 1.864 1.709 0 .912-.377 1.499-1.135 1.72zm3.64-.443c0-2.647-2.1-4.76-4.734-4.76a4.728 4.728 0 00-4.761 4.76 4.726 4.726 0 004.761 4.748 4.72 4.72 0 004.734-4.748zm.769 0c0 3.026-2.478 5.516-5.503 5.516-3.051 0-5.53-2.49-5.53-5.516 0-3.039 2.479-5.542 5.53-5.542 3.025 0 5.503 2.503 5.503 5.542z"
  }));
}
const ForwardRef = React.forwardRef(YemaLogoHorizontalBlackIcon);
module.exports = ForwardRef;

/***/ })

}]);